var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grey lighten-4" },
    [
      _c("SubHeader", { attrs: { id: "v-step-0" } }),
      _c("div", { attrs: { id: "tourContainer" } }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showReportGeneratorDiv,
              expression: "showReportGeneratorDiv"
            }
          ],
          attrs: { id: "reportGeneratorDiv" }
        },
        [
          _c("v-img", {
            staticClass: "v-step-12",
            attrs: { src: _vm.reportGenImg, contain: "" }
          })
        ],
        1
      ),
      _vm.showRegistration
        ? _c("Registration", {
            on: { SubmitReg: _vm.showRegistrationMessage },
            model: {
              value: _vm.showRegistration,
              callback: function($$v) {
                _vm.showRegistration = $$v
              },
              expression: "showRegistration"
            }
          })
        : _vm._e(),
      _c("InfoMessage", {
        attrs: { msg: _vm.infoMessage, title: _vm.infoMessageTitle },
        on: { input: _vm.onRegDone },
        model: {
          value: _vm.showInfoMsg,
          callback: function($$v) {
            _vm.showInfoMsg = $$v
          },
          expression: "showInfoMsg"
        }
      }),
      _c("MainContent"),
      _c("v-tour", {
        attrs: {
          name: "timberTourDesign",
          steps: _vm.stepsDesign,
          options: { highlight: true }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(tour) {
              return [
                _c(
                  "transition",
                  { attrs: { name: "fade" } },
                  [
                    tour.steps[tour.currentStep]
                      ? _c(
                          "v-step",
                          {
                            key: tour.currentStep,
                            attrs: {
                              step: tour.steps[tour.currentStep],
                              "previous-step": tour.previousStep,
                              "next-step": tour.nextStep,
                              stop: tour.stop,
                              skip: _vm.onSkipTourDesign,
                              finish: _vm.onFinishTourDesign,
                              "is-first": tour.isFirst,
                              "is-last": tour.isLast,
                              highlight: tour.highlight,
                              labels: tour.labels
                            }
                          },
                          [
                            tour.currentStep !== 3
                              ? [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "actions" },
                                      slot: "actions"
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass:
                                            "v-step__buttons my-2 mx-5",
                                          attrs: { "no-gutters": "" }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "v-step__button",
                                              on: {
                                                click: _vm.onSkipTourDesign
                                              }
                                            },
                                            [_vm._v("Skip")]
                                          ),
                                          _c("v-spacer"),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "v-step__button",
                                              on: { click: tour.previousStep }
                                            },
                                            [_vm._v("Previous")]
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "v-step__button",
                                              on: { click: tour.nextStep }
                                            },
                                            [_vm._v("Next")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              : _vm._e(),
                            tour.currentStep === 3
                              ? [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "actions" },
                                      slot: "actions"
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass:
                                            "v-step__buttons my-2 mx-5",
                                          attrs: { "no-gutters": "" }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "v-step__button",
                                              on: { click: tour.previousStep }
                                            },
                                            [_vm._v("Previous")]
                                          ),
                                          _c("v-spacer"),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "v-step__button",
                                              on: {
                                                click: _vm.onFinishTourDesign
                                              }
                                            },
                                            [_vm._v("Next")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c("v-tour", {
        attrs: {
          name: "timberTour",
          steps: _vm.steps,
          options: { highlight: true }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(tour) {
              return [
                _c(
                  "transition",
                  { attrs: { name: "fade" } },
                  [
                    tour.steps[tour.currentStep]
                      ? _c(
                          "v-step",
                          {
                            key: tour.currentStep,
                            attrs: {
                              step: tour.steps[tour.currentStep],
                              "previous-step": tour.previousStep,
                              "next-step": tour.nextStep,
                              stop: tour.stop,
                              skip: _vm.onSkipTour,
                              finish: _vm.onStartDesigning,
                              "is-first": tour.isFirst,
                              "is-last": tour.isLast,
                              highlight: tour.highlight,
                              labels: tour.labels
                            }
                          },
                          [
                            !tour.isFirst && !tour.isLast
                              ? [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "actions" },
                                      slot: "actions"
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass:
                                            "v-step__buttons my-2 mx-5",
                                          attrs: { "no-gutters": "" }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "v-step__button",
                                              on: { click: _vm.onSkipTour }
                                            },
                                            [_vm._v("Skip")]
                                          ),
                                          _c("v-spacer"),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "v-step__button",
                                              on: { click: tour.previousStep }
                                            },
                                            [_vm._v("Previous")]
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "v-step__button",
                                              on: { click: tour.nextStep }
                                            },
                                            [_vm._v("Next")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              : _vm._e(),
                            tour.isFirst
                              ? [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "actions" },
                                      slot: "actions"
                                    },
                                    [
                                      _c("hr"),
                                      _c(
                                        "v-row",
                                        {
                                          staticClass:
                                            "v-step__buttons my-2 mx-3",
                                          attrs: { "no-gutters": "" }
                                        },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              staticClass:
                                                                "v-step__button v-step__button-skip",
                                                              on: {
                                                                click:
                                                                  _vm.onSkipTour
                                                              }
                                                            },
                                                            on
                                                          ),
                                                          [_vm._v("Skip")]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [_c("span", [_vm._v("Skip tour")])]
                                          ),
                                          _c("v-spacer"),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "auto" } },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { top: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "v-step__button v-step__button-next mr-2",
                                                                  on: {
                                                                    click:
                                                                      tour.nextStep
                                                                  }
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _vm._v(
                                                                  "Tour Functionality"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Approx. 7 min guided tour explaining all the functions included in timberX"
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { top: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "v-step__button",
                                                                  on: {
                                                                    click:
                                                                      _vm.onStartDesigning
                                                                  }
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _vm._v(
                                                                  "Start Designing"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Follow 3 simple prompts to start your design"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              : _vm._e(),
                            tour.isLast
                              ? [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "actions" },
                                      slot: "actions"
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass:
                                            "v-step__buttons my-2 mx-5",
                                          attrs: { "no-gutters": "" }
                                        },
                                        [
                                          _c("v-spacer"),
                                          _c(
                                            "v-btn",
                                            {
                                              on: { click: tour.previousStep }
                                            },
                                            [_vm._v("Previous")]
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ml-2",
                                              on: {
                                                click: _vm.onStartDesigning
                                              }
                                            },
                                            [_vm._v("Start Designing")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c("v-tour", {
        attrs: {
          name: "systemCostTour",
          steps: _vm.systemCostSteps,
          options: { highlight: true }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(tour) {
              return [
                _c(
                  "transition",
                  { attrs: { name: "fade" } },
                  [
                    tour.steps[tour.currentStep]
                      ? _c(
                          "v-step",
                          {
                            key: tour.currentStep,
                            staticClass: "costtour-step",
                            attrs: {
                              step: tour.steps[tour.currentStep],
                              "previous-step": tour.previousStep,
                              "next-step": tour.nextStep,
                              stop: tour.stop,
                              "is-first": tour.isFirst,
                              "is-last": tour.isLast,
                              highlight: tour.highlight,
                              labels: tour.labels
                            }
                          },
                          [
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("h2", [
                                    _vm._v(
                                      "A note about the Structural Floor System Cost"
                                    )
                                  ]),
                                  _c(
                                    "v-sheet",
                                    { staticClass: "d-flex align-start ma-2" },
                                    [
                                      _c(
                                        "v-sheet",
                                        { staticClass: "text-left" },
                                        [
                                          _c(
                                            "v-container",
                                            [
                                              _c("p", [
                                                _vm._v(
                                                  "The structural floor system cost is for supply and install. Click the info icon to review the detail cost assumptions and unit rates."
                                                )
                                              ]),
                                              _c(
                                                "v-container",
                                                {
                                                  staticClass:
                                                    "d-flex mx-0 px-0"
                                                },
                                                [
                                                  _c("v-img", {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      "max-width": "24",
                                                      src: _vm.ideaIcon
                                                    }
                                                  }),
                                                  _c("h3", [
                                                    _vm._v("Did you know?")
                                                  ])
                                                ],
                                                1
                                              ),
                                              _c("span", [
                                                _vm._v(
                                                  "In residential construction, the cost of the structural floor system is 15-25% of the overall cost. The structural floor system premiums are offset by other benefits across the project (structural or non-structural)."
                                                )
                                              ]),
                                              _c("br"),
                                              _c("br"),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "floor-cost-footer"
                                                },
                                                [
                                                  _vm._v(
                                                    "When you are done designing, click the generate a report to learn more about these benefits"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-sheet",
                                        { staticClass: "my-auto" },
                                        [
                                          _c("v-img", {
                                            staticClass: "v-step-final",
                                            attrs: {
                                              "max-height": "358",
                                              cover: "",
                                              src: _vm.floorSystemCost
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { attrs: { slot: "actions" }, slot: "actions" },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "v-step__buttons my-2 mx-5",
                                      attrs: { "no-gutters": "" }
                                    },
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "v-step__button",
                                          on: { click: _vm.onFinishSystemCost }
                                        },
                                        [_vm._v("Done")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("div", {
                                staticClass: "v-step__arrow",
                                staticStyle: {
                                  position: "absolute",
                                  top: "0px",
                                  transform: "translate(0px, 242px)"
                                }
                              })
                            ]
                          ],
                          2
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }